// Brengen en halen per dag (0022, verzoek oprichter 2026-09-24): in de afspraak-editor wie brengt
// en haalt (met gezichtjes, en "Per dag anders" bij een herhaling op meer dagen), en op het
// afspraakblad en de pagina Ritten "Kan niet? Iemand anders" voor één dag. Sleutels in
// `a.ridesPerDay.*` (app.nl.ts). Toon: je-vorm, korte zinnen, werkwoorden op knoppen.
export const appRidesNl = {
    // ---- Editor --------------------------------------------------------------------------------
    unknown: 'Nog niet bekend',
    notNeeded: 'Niet nodig',
    perDay: 'Per dag anders',
    /** {a} en {b}: de eerste twee volwassenen van het gezin. */
    perDayHint: 'Bijvoorbeeld maandag {a} en donderdag {b}.',
    perDayHintOne: 'Bijvoorbeeld op maandag iemand anders dan op donderdag.',
    sameEveryDay: 'Elke keer dezelfde',
    day: 'Dag',
    /** Schermlezer: "Brengen op maandag". */
    roleOnDay: '{role} op {day}',
    change: 'Wijzigen',
    close: 'Klaar',
    droppedDays: {
        one: 'Wie er op {days} rijdt, vervalt: die dag zit niet meer in de herhaling.',
        other: 'Wie er op {days} rijdt, vervalt: die dagen zitten niet meer in de herhaling.',
    },
    // ---- Eén keer overnemen (afspraakblad, Ritten) --------------------------------------------
    cantDrive: 'Kan niet? Iemand anders',
    /** Eigen rit: laat hem open ("Wie rijdt?"), de ander ziet hem. */
    iCant: 'Ik kan niet, laat open',
    /** Eigen rit: meteen kiezen wie het overneemt. */
    someoneElse: 'Iemand anders rijdt',
    whoInstead: 'Wie {role} er op {date}?',
    whoInsteadHint: 'Alleen deze keer. De andere keren blijven zoals ze zijn.',
    onlyThisTime: 'Alleen deze keer',
    usually: 'normaal {name}',
    usuallyNobody: 'normaal nog niemand',
    everyWeekday: 'elke {day}',
    backToUsual: 'Terug naar normaal',
    takenOver: '{name} {role} deze keer',
    /** {role} = "Brengen" of "Halen": bij twee meldingen weet je welke bij welke rit hoort. */
    nobodyNow: '{role} staat deze keer op "Wie rijdt?". De anderen zien het.',
    backDone: '{role} weer zoals normaal',
    /** Werkwoord in "Wie brengt er op ...?" en "Anne brengt deze keer". */
    verbDropoff: 'brengt',
    verbPickup: 'haalt',
};
//# sourceMappingURL=ridesApp.nl.js.map